import React, { Component,Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';

const required = value => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">
          Este campo es obligatorio!
        </div>
      );
    }
  };

export class Ver_edit_product_collection extends Component {
    constructor(props) {
        super(props);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.onChangeCollectionName = this.onChangeCollectionName.bind(this);
        this.onChangeCollectionCode = this.onChangeCollectionCode.bind(this);
        this.onChangeDescription = this.onChangeDescription.bind(this);
        this.onChangeStatus = this.onChangeStatus.bind(this);

        this.state = {
            collection_name: "",
            collection_code: "",
            description: "",
            collection_status: "ACTIVO",
            errors: {},
            loading: false,
        }
    }

    componentWillMount() {
        this.getDataCollection();
    }

    onChangeCollectionName(e) {
        this.setState({
            collection_name: e.target.value
        });
      }

      onChangeCollectionCode(e) {
        this.setState({
            collection_code: e.target.value
        });
      }

      onChangeDescription(e) {
        this.setState({
            description: e.target.value
        });
      }

      onChangeStatus(e) {
        this.setState({
            collection_status: e.target.value
        });
      }

      getDataCollection(){
        var user = AuthService.getCurrentUser();
        let id_collection = this.props.match.params.id;
        ApiService.getProductCollectionDetails(user.token, id_collection).then(
            (res) => {
                if(res && res.status === 'success')
                {
                    this.setState({
                        collection_name: res.data.collection_name,
                        collection_code: res.data.collection_code || "",
                        description: res.data.description || "",
                        collection_status: res.data.collection_status,
                    });
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

      handleUpdate(e) {
        e.preventDefault();

        this.form.validateAll();

        if (this.checkBtn.context._errors.length === 0) {
            this.setState({
                message: "",
                loading: true
              });
            var user = AuthService.getCurrentUser();
            let id_collection = this.props.match.params.id;
            let data_collection = {
                'id_collection': id_collection,
                'collection_name': this.state.collection_name,
                'collection_code': this.state.collection_code,
                'description': this.state.description,
                'collection_status': this.state.collection_status,
            }

            ApiService.putProductCollection(user.token, data_collection).then(
            (res) => {
                if(res){
                    if(res.status == 'success')
                    {
                        this.props.history.push("/product-collections");
                        toast.success("Colección actualizada!");
                    }
                    else
                    {
                        toast.error(res.message);
                        this.setState({
                            loading: false
                        });
                    }
                }else{
                    this.setState({
                        loading: false
                    });
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
              this.setState({
                loading: false
              });
              toast.error("Ha ocurrido un error!");
            }
          );
        }
      }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Editar Colección de Productos" parent="Promociones" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Editar Colección de Productos</h5>
                                </div>
                                <div className="card-body">
                                <Form
                                    onSubmit={this.handleUpdate}
                                    ref={c => {
                                        this.form = c;
                                    }}
                                >
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Nombre de la Colección</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                name="collection_name"
                                                placeholder="Ej: Productos Frescos del Día"
                                                value={this.state.collection_name}
                                                onChange={this.onChangeCollectionName}
                                                validations={[required]}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Código de la Colección</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                name="collection_code"
                                                placeholder="Ej: FRESCOS_DIA (Opcional)"
                                                value={this.state.collection_code}
                                                onChange={this.onChangeCollectionCode}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Descripción</label>
                                        <div className="col-md-7">
                                            <textarea
                                                className="form-control"
                                                name="description"
                                                rows="3"
                                                placeholder="Descripción de la colección (Opcional)"
                                                value={this.state.description}
                                                onChange={this.onChangeDescription}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Estado</label>
                                        <div className="col-md-7">
                                            <select
                                                name="collection_status"
                                                className="form-control"
                                                value={this.state.collection_status}
                                                onChange={this.onChangeStatus}
                                            >
                                                <option value="ACTIVO">ACTIVO</option>
                                                <option value="INACTIVO">INACTIVO</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="pull-right">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={this.state.loading}
                                        >
                                            {this.state.loading && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                            )}
                                            Actualizar
                                        </button>
                                    </div>
                                    <CheckButton
                                        style={{ display: "none" }}
                                        ref={c => {
                                        this.checkBtn = c;
                                        }}
                                    />
                                </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Ver_edit_product_collection
